/* eslint-disable */
import { Specification } from '../models/specification.model';

export const SpecificationsData: Specification[] = [
  {
    name: 'Energy Class',
    value: 'A+',
  },
  {
    name: 'Dimensions',
    value: 'H81 x W59.8 x D55cm',
  },
  {
    name: 'Place Settings Qty',
    value: '13',
  },
  {
    name: 'Drying Class',
    value: 'Class A',
  },
  {
    name: 'Maximum Noise Level',
    value: '49 db',
  },
  {
    name: 'Form Factor',
    value: 'Freestanding',
  },
  {
    name: 'Colour',
    value: 'White',
  },
  {
    name: 'Washing Efficiency',
    value: 'Class A',
  },
  {
    name: 'Programs Qty',
    value: '6',
  },
  {
    name: 'Energy Consumption per Cycle',
    value: '1.04 KWh',
  },
  {
    name: 'Water Consumption per Cycle',
    value: '11 litres',
  },
  {
    name: 'Weight',
    value: '47kg',
  },
];

export const SpecificationsData2: Specification[] = [
  {
    name: 'Energy Class',
    value: 'B+',
  },
  {
    name: 'Bluetooth',
    value: 'Yes',
  },
  {
    name: 'Dimensions',
    value: 'H100 x W60.8 x D45cm',
  },
  {
    name: 'Maximum Noise Level',
    value: '40 db',
  },
  {
    name: 'Form Factor',
    value: 'Freestanding',
  },
  {
    name: 'Colour',
    value: 'White',
  },
  {
    name: 'Washing Efficiency',
    value: 'Class B',
  },
  {
    name: 'Programs Qty',
    value: '5',
  },
  {
    name: 'Energy Consumption per Cycle',
    value: '1.04 KWh',
  },
  {
    name: 'Water Consumption per Cycle',
    value: '11 litres',
  },
  {
    name: 'Weight',
    value: '47kg',
  },
];

export const SpecificationsData3: Specification[] = [
  {
    name: 'Energy Class',
    value: 'C+',
  },
  {
    name: 'Maximum Noise Level',
    value: '39 db',
  },
  {
    name: 'Colour',
    value: 'Black',
  },
  {
    name: 'Washing Efficiency',
    value: 'Class C',
  },
  {
    name: 'Programs Qty',
    value: '5',
  },
  {
    name: 'Energy Consumption per Cycle',
    value: '1.05 KWh',
  },
  {
    name: 'Water Consumption per Cycle',
    value: '12 litres',
  },
  {
    name: 'Hard Water Filter',
    value: 'Yes',
  },
  {
    name: 'Bluetooth',
    value: 'No',
  },
  {
    name: 'Dimensions',
    value: 'H81 x W33.8 x D55cm',
  },
  {
    name: 'Weight',
    value: '49kg',
  },
];
